export default __webpack_public_path__ + "static/media/lock-chart-dark.2098e3be.svg";